import { DefaultAfrrFormValues, DefaultFormValues } from "../types";

const defaultAfrrFormValues: DefaultAfrrFormValues = {
  initial_soc_restoration_power: {},
  afrr_engagement_up: {},
  afrr_engagement_down: {},
  reactivity_delay: 0,
};

export const getDefaultFormValues = (): DefaultFormValues => ({
  rampTest1: {
    afrr_active: true,
    plannings_soc_management: { active: true, target_soc: {}, duration: 60 },
    plannings_afrr_phase1: defaultAfrrFormValues,
    plannings_afrr_phase2: defaultAfrrFormValues,
  },
  rampTest2: {
    afrr_active: true,
    plannings_soc_management: { active: true, target_soc: {}, duration: 55 },
    plannings_afrr_phase1: defaultAfrrFormValues,
    plannings_afrr_phase2: defaultAfrrFormValues,
  },
});
